module.exports = __webpack_public_path__ + "static/img/USF1816P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/USF1816P_1.png
// module id = rEMQ
// module chunks = 0